export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export const MIN_PASSWORD_LENGTH = 8;

export const FORM_CONTROL_SX = { width: { xs: "100%", sm: "70%" } };

export const ERROR_TEXT_SX = { color: "#f02849", marginTop: -2 };

export const isValidEmail = (value: string) => EMAIL_REGEX.test(value);
